"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function getUtcString(value) {
    var numericValue = lodash_1.isNumber(value) ? value : parseInt(value, 10);
    var isTimestamp = lodash_1.isNumber(value) || lodash_1.isEqual(lodash_1.toString(numericValue), value);
    var dateTime = isTimestamp
        ? new Date(numericValue * 1000)
        : new Date(value);
    return dateTime.toUTCString();
}
exports.getUtcString = getUtcString;
